import { render, staticRenderFns } from "./detailModalComp.vue?vue&type=template&id=244cf6fb&scoped=true"
import script from "./detailModalComp.vue?vue&type=script&lang=js"
export * from "./detailModalComp.vue?vue&type=script&lang=js"
import style0 from "./detailModalComp.vue?vue&type=style&index=0&id=244cf6fb&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244cf6fb",
  null
  
)

export default component.exports